module.exports = __webpack_public_path__ + "static/img/zapier.a915616.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/integrations/zapier.png
// module id = 625
// module chunks = 2